"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorCodeCreateDto = void 0;
const class_validator_1 = require("class-validator");
const mappable_base_1 = require("../../mappable.base");
const class_transformer_1 = require("class-transformer");
const default_behavior_code_reaction_create_dto_1 = require("../behavior-code-reactions/default-behavior-code-reaction-create.dto");
const boolean_transform_1 = require("../../constants/boolean.transform");
class BehaviorCodeCreateDto extends mappable_base_1.MappableBase {
    constructor(behaviorCodeOptions) {
        super();
        if (!behaviorCodeOptions)
            return;
        this.code = behaviorCodeOptions.code;
        this.description = behaviorCodeOptions.description;
        this.passMessage = behaviorCodeOptions.passMessage;
        this.printPass = behaviorCodeOptions.printPass;
        this.active = behaviorCodeOptions.active;
        this.behaviorCodeTypeId = behaviorCodeOptions.behaviorCodeTypeId;
        this.behaviorDistrictCodeId = behaviorCodeOptions.behaviorDistrictCodeId;
        this.externalReferenceCode = behaviorCodeOptions.externalReferenceCode;
        this.fastTrack = behaviorCodeOptions.fastTrack;
        this.defaultBehaviorCodeReaction =
            behaviorCodeOptions.defaultBehaviorCodeReaction;
    }
    getFields() {
        return [
            'code',
            'description',
            'passMessage',
            'printPass',
            'active',
            'fastTrack',
            'behaviorCodeTypeId',
            'schoolId',
            'externalReferenceCode',
            'behaviorDistrictCodeId'
        ];
    }
    code;
    description;
    passMessage;
    printPass;
    fastTrack;
    active;
    behaviorCodeTypeId;
    behaviorDistrictCodeId;
    externalReferenceCode;
    schoolId;
    defaultBehaviorCodeReaction;
}
exports.BehaviorCodeCreateDto = BehaviorCodeCreateDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(50),
    __metadata("design:type", String)
], BehaviorCodeCreateDto.prototype, "code", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(250),
    __metadata("design:type", String)
], BehaviorCodeCreateDto.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(512),
    __metadata("design:type", String)
], BehaviorCodeCreateDto.prototype, "passMessage", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], BehaviorCodeCreateDto.prototype, "printPass", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], BehaviorCodeCreateDto.prototype, "fastTrack", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], BehaviorCodeCreateDto.prototype, "active", void 0);
__decorate([
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorCodeCreateDto.prototype, "behaviorCodeTypeId", void 0);
__decorate([
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], BehaviorCodeCreateDto.prototype, "behaviorDistrictCodeId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(50),
    __metadata("design:type", String)
], BehaviorCodeCreateDto.prototype, "externalReferenceCode", void 0);
__decorate([
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], BehaviorCodeCreateDto.prototype, "schoolId", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => default_behavior_code_reaction_create_dto_1.DefaultBehaviorCodeReactionCreateDto),
    (0, class_validator_1.ValidateNested)({ message: 'default reaction validation failed' }),
    __metadata("design:type", default_behavior_code_reaction_create_dto_1.DefaultBehaviorCodeReactionCreateDto)
], BehaviorCodeCreateDto.prototype, "defaultBehaviorCodeReaction", void 0);
